<template>

    <button href="#" class="template-btn" @click.prevent="goToTemplate">{{titleToOutput}} <i v-if="templateRecord.children.length > 0" class="ml-1 fas fa-chevron-right" aria-label="Go to all mailboxes for this group"></i></button>

</template>

<script>

    import Vue from 'vue';

    export default {
        name: 'templateRecordSelector',
        props: {
            titleToOutput: { type: String },
            templateRecord: { type: Object },
        },
        methods: {

            goToTemplate: function () {
                this.$emit('itemSelected', this.templateRecord);
            }

        }
    };
</script>

